import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./invoice.css";
import Item_card from "./Item_card";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProduct } from "../../redux/features/product.features";
import {
  addInvoiceType,
  addToCart,
  removeAllItemFromCart,
  removeItemFromCart,
} from "../../redux/features/sales.features";
import Item_cardEditInvoice from "./Item_cardEditInvoice";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const InvoiceProdList = (props) => {
  let dispatch = useDispatch();
  let salesState = useSelector((state) => {
    return state.salesReducer;
  });
  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let { products } = productState;
  let { invoice, sales, loading } = salesState;
  let { foreignInvoice, invoiceType, invoiceItemList } = invoice;

  const [checked, setChecked] = useState(foreignInvoice);
  const [onapproval, setonapproval] = useState(
    invoiceType === "sales" ? false : true
  );
  const handleChange = (e) => {
    setChecked(e.target.checked);
    const payload = {
      foreignInvoice: e.target.checked,
      invoiceType: onapproval ? "onapproval" : "sales",
    };
    dispatch(addInvoiceType(payload));
  };

  const handleChangeOnapproval = (e) => {
    setonapproval(e.target.checked);

    const payload = {
      foreignInvoice: false,
      invoiceType: e.target.checked ? "onapproval" : "sales",
    };
    if (e.target.checked) setChecked(false);
    dispatch(addInvoiceType(payload));
  };

  let limit = 30;
  let iniProducts = products
    .filter((p) => !p.isSold)
    .sort((a, b) => a.productId < b.productId);
  const initDataShow = iniProducts?.slice(0, Number(limit));

  const [dataShow, setDataShow] = useState(initDataShow);
  const [checkedAll, setCheckedAll] = React.useState(false);

  const handleChangeAll = (event) => {
    setCheckedAll(event.target.checked);

    let checkedDataShow = [];
    dataShow.map((x) => {
      let convertedObj = JSON.parse(JSON.stringify(x));
      convertedObj.checked = event.target.checked;

      if (!x.isSold) checkedDataShow.push(convertedObj);
    });
    console.log("convertedObj", checkedDataShow);

    if (event.target.checked) setDataShow(checkedDataShow);

    if (event.target.checked) addItemToCartBulk();
    if (!event.target.checked) removeItemToCartBulk();
  };
  let pages = 1;

  let range = [];

  if (iniProducts.length >= Number(limit)) {
    let page = Math.floor(iniProducts.length / Number(limit));
    pages = iniProducts.length % Number(limit) === 0 ? page : page + 1;
    range = [...Array(pages).keys()];
  }

  const [currPage, setCurrPage] = useState(0);
  const [notAvailable, setNotAvailable] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const selectPage = (page) => {
    const start = Number(limit) * page;
    const end = start + Number(limit);

    setDataShow(iniProducts.slice(start, end));

    setCurrPage(page);
  };

  const addItemToCartBulk = () => {
    // if((invoiceItemList || []).filter(x=> x.id === data.id).length !==0) return alert("Cannot add same item again")
    let tempArr = [];
    dataShow.map((x) => {
      let convertedObj = JSON.parse(JSON.stringify(x));
      convertedObj.checked = true;

      if (!x.isSold) {
        tempArr.push(convertedObj);
      }
    });

    if (tempArr.length > 0) {
      let a = [...invoiceItemList, tempArr];
      dispatch(addToCart(tempArr));
    }
  };
  const removeItemToCartBulk = () => {
    dispatch(removeAllItemFromCart());
  };

  useEffect(() => {
    if (searchValue !== "") {
      let searchIds = searchValue.split(",");

      if (searchIds[searchIds.length - 1] !== "") {
        console.log("searchIds", searchIds);

        searchIds.filter((x) => {
          if (products.find((y) => y.productId === x && !y.isSold)) {
            console.log("Found", x);
            setNotAvailable(false);
          } else {
            setNotAvailable(true);
            console.log("Not Found", x);
          }
        });
      } else {
        setNotAvailable(false);
      }
    }
  }, [searchValue]);

  const searchAll = () => {
    if (searchValue !== "") {
      let searchIds = searchValue.split(",").map((x) => x.trim());

      let filteredData = products.filter((x) => {
        return searchIds.includes(x.productId) && !x.isSold;
      });

      setDataShow(filteredData);
    } else {
      setDataShow(iniProducts);
    }
  };
  return (
    <div className="flex flex-col   w-full">
      <div>{props.mod}</div>
      <div className="flex justify-between items-center">
        <div style={{width:400}}>
          <Button onClick={()=>props.onClose()} size="large" variant="contained" color="primary">
            Done
          </Button>
        </div>
        <div style={{maxWidth:800}} className="flex w-full  justify-start items-center">
          <div className="flex  w-6/12 flex-col">
            <TextField
              inputProps={{ style: { width: 1200 } }}
              placeholder="item code..."
              style={{ borderRadius: 10 }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);

                if (e.target.value !== "") {
                  let searchIds = e.target.value
                    .split(",")
                    .map((x) => x.trim());

                  let filteredData = products.filter((x) => {
                    return searchIds.includes(x.productId) && !x.isSold;
                  });

                  setDataShow(filteredData);
                } else {
                  setDataShow(iniProducts);
                }
              }}
              name="item_search"
            />
          </div>

          <Button
            style={{width:200, padding:10, margin:10}}
            onClick={() => searchAll()}
            className="flex  bx bx-search"
            variant="contained"
          >
            Search
          </Button>

          <FormGroup className="flex w-6/12 p-5">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedAll}
                  onChange={handleChangeAll}
                  inputProps={{ "aria-label": "controlled" }}
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                />
              }
              label="Select All"
            />
          </FormGroup>
        </div>
      </div>
      <div className="flex justify-start w-4/12">
        {searchValue !== "" &&
          searchValue.split(",")[searchValue.split(",").length - 1] !== "" && (
            <p
              className={`m-3 rounded-full  p-2 mx-4 text-white font-extrabold ${
                notAvailable ? "bg-red-400" : "bg-green-400"
              }`}
            >
              {notAvailable ? "Item not available" : "Available"}
            </p>
          )}
      </div>
      <div className="flex flex-col w-full h-full">
        <div className="grid grid-flow-row auto-row-max grid-cols-6 gap-4  hover:cursor-pointer text-center  ">
          {products ? (
            dataShow.map((x, i) => {
              return (
                <React.Fragment key={i}>
                  {props.mod && props.mod === "edit" ? (
                    <Item_cardEditInvoice
                    invoiceCurrency={props.invoiceCurrency}
                      updateCart={props.updateCart}
                      checked={x.checked || false}
                      data={x}
                    />
                  ) : (
                    <Item_card
                      invoiceCurrency={props.invoiceCurrency}
                      updateCart={props.updateCart}
                      checked={x.checked || false}
                      data={x}
                    />
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <p>No Items Available</p>
          )}
        </div>
        <div className="">
          {pages > 1 ? (
            <div className="table__pagination">
              {range.map((item, index) => (
                <div
                  key={index}
                  className={`table__pagination-item ${
                    currPage === index ? "active" : ""
                  }`}
                  onClick={() => selectPage(index)}
                >
                  {item + 1}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default InvoiceProdList;
